//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const styles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#305698!important",
    color: "#fff",
    width: "initial !important",
    fontFamily: "segoe-ui",
    marginBottom: 20,
    "@media (max-width: 600px)": {
      margin: 0,
    },
  },
  headerText: {
    textAlign: "left",
    font: "normal normal normal 1.5vw Segoe-ui",
    marginBottom: 0,
    letterSpacing: "0px",
    color: " #707070",
    fontSize: 28,
    display: "block",
    textAlign: "center",
  },
  headingText: {
    padding: 10,
    textAlign: "center",
    fontSize: 25,
    fontFamily: "segoe-ui",
    backgroundColor: "#305698",
    color: "#fff",
  },
  topGrid: {
    marginBottom: 20,
    display: "flex",
  },
  cancelBtn: {

    color: "rgb(55 126 185)",
    backgroundColor: "#dddddd",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#dddddd",
    },
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
    marginBottom: theme.spacing(2),
  },
  control: {
    padding: theme.spacing(2),
  },
  input: {
    width: "30%",
  },
  inputContainer: {
    padding: "20px 20px",
  },
  // table
  table: {
    minWidth: 750,
  },
  tableHeader: {
    background: "#EDEDED",
    boxShadow:
      "rgb(112 112 112 / 60%) 0px 1.5px 4px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 1px 0px, rgb(255 255 255) 0px -4px 0px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 0px 0px",
  },
  rowCell: {
    fontSize: 15,
    fontFamily: "segoe-ui",
    padding: "5px",
    border: "1px solid grey",
  },
  tableContainer: {},
  tableHeading: {
    color: "#000",
    fontWeight: "bold",
    fontSize: 16,
    fontFamily: "segoe-ui !important",
    padding: 5,
    border: "1px solid",
  },
  filterBtn: {
    marginLeft: 20,
    alignSelf: "flex-end",
    backgroundColor: "#305698!important",
  },
  uploadBtn: {
    color: "#fff",
    width: 150,
    height: 40,
    fontSize: 18,
    fontFamily: "segoe-ui",
    borderRadius: 5,
    textTransform: "capitalize",
    backgroundColor: "#305698!important",
    margin: 10,
    outline: "none",
    "&:hover": {
      backgroundColor: "#305698!important",
    },
    "&:active": {
      outline: "none",
    },
    "&:focus": {
      outline: "none",
    },
  },

  tableHeading: {
    color: "#000",
    fontWeight: "bold",
    fontSize: "0.875rem",
    fontFamily: "segoe-ui !important",
    padding: 5,
    border: "1px solid",
  },
  filterBtn: {
    marginLeft: 20,
    alignSelf: "flex-end",
    backgroundColor: "#305698!important",
  },
  uploadBtn: {
    color: "#fff",
    width: 150,
    height: 40,
    fontSize: 18,
    fontFamily: "segoe-ui",
    borderRadius: 5,
    textTransform: "capitalize",
    backgroundColor: "#305698!important",
    margin: 10,
    outline: "none",
    "&:hover": {
      backgroundColor: "#305698!important",
    },
    "&:active": {
      outline: "none",
    },
    "&:focus": {
      outline: "none",
    },
  },

  uploadBtnDisabled: {
    color: "#666666",
    width: 150,
    height: 40,
    fontSize: 18,
    fontFamily: "segoe-ui",
    borderRadius: 5,
    textTransform: "capitalize",
    backgroundColor: "#cccccc!important",
    margin: 10,
    outline: "none",
    "&:hover": {
      backgroundColor: "#305698!important",
    },
    "&:active": {
      outline: "none",
    },
    "&:focus": {
      outline: "none",
    },
  },
  appBarText: {
    fontSize: 34,
    verticalAlign: "middle",
    "@media (max-width: 600px)": {
      fontSize: 22,
    },
  },
  // Max Merch Search
  headingText: {
    padding: 10,
    fontSize: 25,
    fontFamily: "segoe-ui",
    color: "#2F7CBD",
  },
  headingText2Grid: {
    padding: "20px 20px 30px 20px",
    "@media (max-width: 600px)": {
      padding: 0,
    },
  },
  headingText2: {
    paddingBottom: 20,
    fontSize: 20,
    fontFamily: "segoe-ui",
    width: "100%",
    fontWeight: "bold",
    "@media (max-width: 600px)": {
      padding: 10,
    },
  },
  updateBtnGrid: {
    padding: 15,
  },
  updateBtn: {
    color: "#fff",
    backgroundColor: "#305698",
    fontSize: 15,
    borderRadius: 10,
    width: 100,
    height: 35,
    textTransform: "capitalize",
    fontFamily: "segoe-ui",
    float: "right",
    "&:hover": {
      backgroundColor: "#305698!important",
    },
  },
  // ACH Confirmation styles
  contentGrid: {
    textAlign: "center",
  },
  backArrow: {
    fontSize: "30px",
    marginLeft: "1rem",
    cursor: "pointer",
  },
  checkIcon: {
    fontSize: 80,
    color: "green",
    verticalAlign: "middle",
  },
  content1: {
    fontSize: 25,
    fontWeight: "bold",
    padding: 30,
    textAlign: "center",
  },
  content2: {
    fontSize: 18,
    width: "90%",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 50,
  },
  pagination: {
    padding: 0,
    marginTop: 30,
    float: "right",
  },
  backBtn: {
    border: "none",
    backgroundColor: "#0a72ba",
    color: "#fff",
    borderRadius: "5px",
    marginTop: 5,
    marginBottom: 20,
    cursor: "pointer",
    padding: "4px 8px",
    "&:hover":{
      backgroundColor: "#0a72ba",
    }
  },
}));
